import React from 'react'
import { MarketEMP } from '../../../types/database'
import InlineSelectEditor from '../../inline-editors/InlineSelectEditor'
import { CellBaseProps, resolveOverrideContext, isFieldEditing, makeEditClickHandler, makeFieldSaveHandler, overrideEditableClass } from './types'

interface EMPCellProps extends CellBaseProps {
  marketEmps: MarketEMP[]
}

/**
 * Renders the EMP (Engine Maintenance Program) column cell.
 */
export function EMPCell(props: EMPCellProps) {
  const { cellBorderClass, effectiveAircraft, aircraftTransaction, marketEmps } = props
  const { isSoldWithTransaction, isEditable, transOverride, override } = resolveOverrideContext(props)

  const hasOverride = isSoldWithTransaction
    ? (transOverride?.emp != null)
    : (override?.emp != null)

  const currentValue = isSoldWithTransaction
    ? (transOverride?.emp ?? aircraftTransaction!?.emp ?? null)
    : (override?.emp ?? null)

  const isEditing = isFieldEditing(props, 'emp', isSoldWithTransaction)

  return (
    <td className={`px-2 py-2 text-sm text-gray-900 text-center ${cellBorderClass} relative`}>
      <>
        <div
          className={overrideEditableClass(hasOverride, isEditable)}
          onClick={makeEditClickHandler(props, 'emp', isEditable, isSoldWithTransaction)}
        >
          {effectiveAircraft.emp ? (
            effectiveAircraft.emp.includes(' ') ? (
              <div className="flex flex-col">
                {effectiveAircraft.emp.split(' ').map((word, idx) => (
                  <span key={idx}>{word}</span>
                ))}
              </div>
            ) : effectiveAircraft.emp
          ) : '-'}
        </div>
        {isEditing && (
          <InlineSelectEditor
            value={currentValue}
            fieldName="EMP"
            options={marketEmps.map(emp => ({ value: emp.name, label: emp.name }))}
            title="Select Engine Program"
            onSave={makeFieldSaveHandler(props, 'emp', isSoldWithTransaction)}
            onCancel={props.handleCancelEdit}
            allowClear={true}
          />
        )}
      </>
    </td>
  )
}

